import { useUserPerms } from '@utils/useUserPerms';
import { useMemo } from 'react';

export const userPermissions = {
  SUPER_ADMIN: 'super-admin',
  CLIENT: 'client',
  UPDATE: 'update',
  IMAGE: 'image',
  MANAGE: 'manage',
  ANALYTICS: 'analytics',
  OPERATE: 'operate',
  ENROLL: 'enroll',
  VISIT: 'visit',
  VISIT_SCHEDULING: 'visit-scheduling'
};

export const useUserPermissions = () => {
  const { permissions } = useUserPerms();

  let isSuperAdmin = useMemo(() => {
    if (!permissions || !permissions.length) return false;
    return permissions.includes(userPermissions.SUPER_ADMIN);
  }, [permissions]);

  let userHasClientPermission = useMemo(() => {
    if (!permissions || !permissions.length) return false;

    return permissions.includes(userPermissions.CLIENT);
  }, [permissions]);

  let userHasUpdatePermission = useMemo(() => {
    if (!permissions || !permissions.length) return false;
    return permissions.includes(userPermissions.UPDATE);
  }, [permissions]);

  let userHasEnrollPermission = useMemo(() => {
    if (!permissions || !permissions.length) return false;
    return permissions.includes(userPermissions.SUPER_ADMIN) || permissions.includes(userPermissions.ENROLL);
  }, [permissions]);

  let userHasManagePermission = useMemo(() => {
    if (!permissions || !permissions.length) return false;

    return permissions.includes(userPermissions.SUPER_ADMIN) || permissions.includes(userPermissions.MANAGE);
  }, [permissions]);

  return {
    isSuperAdmin,
    userHasClientPermission,
    userHasUpdatePermission,
    userHasEnrollPermission,
    userHasManagePermission
  };
};
